import './bml-our-team.scss';
const TEMPLATE = `
<section class="our-team fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <p class="section-label" data-animate-child>ЛІКАРІ</p>
            </div>
            <div class="col-md-6">
                <h3 class="team-member__name" data-animate-child data-delay="200">Наша медична команда</h3>
                <p class="team-member__description" data-animate-child data-delay="400">
                    BML об'єднує досвідчених патоморфологів, генетиків та біохіміків.
                    Кожен фахівець — це роки практики та міжнародна сертифікація, що гарантує
                    точність кожного висновку та впевненість лікаря у результаті.
                </p>
            </div>
        </div>
        <div class="doctors-carousel-wrapper" data-animate-child data-delay="800">
            <div class="doctors-block" id="doctors-block-1" data-section="carousel"></div>
        </div>
    </div>
</section>
`;

class BmlOurTeam extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
    }
}

customElements.define('bml-our-team', BmlOurTeam);
